type Type =
    | 'number'
    | 'string'
    | 'object'
    | 'array'
    | 'function'
    | 'bigint'
    | 'boolean'
    | 'undefined'
    | 'symbol'
    | (string & {})
    | (number & {});

export class UnexpectedTypeError extends TypeError {
    constructor(name: string, providedType: Type | Type[], expectedType: Type | Type[]) {
        const parsedExpectedType = Array.isArray(expectedType)
            ? expectedType.join(' | ')
            : expectedType;

        const parsedProvidedType = Array.isArray(providedType)
            ? providedType.join(' | ')
            : providedType;

        const message = `An unexpected type was provided. The expected type for \`${name}\` should be \`${parsedExpectedType}\` and not \`${parsedProvidedType}\`.`;

        super(message);
    }
}